import { AxiosResponse } from 'axios';

import { SCIApi, selfCheckInRoute } from 'src/apis';

import { PostDocumentsPayload, Section } from '../documents.types';

export const documentSectionRoute = `${selfCheckInRoute}/contract-sections`;
export const acceptDocumentSectionRoute = `${documentSectionRoute}/accept`;

export const useGetDocumentSectionsKey = 'getDocumentSectionsKey';

export const getDocumentSections = async (): Promise<Section[]> => {
    const apiCalls = SCIApi.getInstance();

    const axiosResult: AxiosResponse<Section[]> = await apiCalls.get<Section[]>(
        documentSectionRoute,
    );

    const result = axiosResult?.data ?? axiosResult;

    return result;
};

export const postDocuments = async (
    payload: PostDocumentsPayload,
): Promise<void> => {
    const apiCalls = SCIApi.getInstance();

    await apiCalls.post(acceptDocumentSectionRoute, payload);
};
